import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function categoryReducer(state = initialState.categories, action) {
  if (action.type === types.LOAD_CATEGORY_DATA_SUCCESS) {
    return action.categories;
  }

  return state;
}
